// Registers the DS remote; isolated so the MF runtime stays off the env.js read path.
import { registerRemotes } from '@module-federation/enhanced/runtime';

/** Register the DS remote; guards a missing/non-string URL (returns false) so a bad value fails soft. */
export function registerDesignSystemRemote(appSettings) {
  const designSystemUrl = appSettings && appSettings.SHIPBOB_DESIGN_SYSTEM;
  if (typeof designSystemUrl !== 'string' || !designSystemUrl.trim()) {
    console.error('[customers-ui] SHIPBOB_DESIGN_SYSTEM missing or invalid in app settings;'
      + ' skipping DS remote registration');
    return false;
  }
  const url = designSystemUrl.trim();
  const origin = url.endsWith('/') ? url.slice(0, -1) : url;
  registerRemotes(
    [{ name: 'shipbob_design_system', entry: `${origin}/remoteEntry.js` }],
    { force: true },
  );
  return true;
}
